import firebase from 'firebase/app'
import "firebase/database"
import "firebase/storage"
import "firebase/auth"
import "firebase/analytics"

  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyC879Hshp6YqLrrVAca_8LkXeZWqXYnGQQ",
    //authDomain: 'auth.productplanet.io',
    authDomain: "productplanet-c3cfb.firebaseapp.com",
    databaseURL: "https://productplanet-c3cfb.firebaseio.com",
    projectId: "productplanet-c3cfb",
    storageBucket: "productplanet-c3cfb.appspot.com",
    messagingSenderId: "426632279561",
    appId: "1:426632279561:web:f032fc33121ba0a68a2ad8",
    measurementId: "G-2SVKG1049E"
  };
firebase.initializeApp(config);
firebase.analytics();

export default firebase;

  